export const styles = {
  presets: {
    marginLeft: '10px',
  },
  group: {
    minHeight: 42,
  },
}
